import { useQuery } from "@tanstack/react-query";

const fetchPlayer = async (id) => {
	const response = await fetch(`/api/player/${id}`, {
		method: "GET",
	});

	if (!response.ok) {
		throw new Error("Could Not Fetch Player Data");
	}

	return response.json();
};

export const usePlayer = (id) => {
	return useQuery({
		queryKey: ["playerData"],
		queryFn: async () => fetchPlayer(id),
		refetchOnWindowFocus: false,
		enabled: true,
	});
};
